<template>
  <div :class="['tag-input', (showTagList || showTagListPermanently) ? 'high-z-index' : '']">
    <div :class="['form-item', showTagListPermanently ? 'with-append-icon' : 'with-prepend-icon'] ">
      <text-input
          id="tagsinput"
          ref="textinput"
          :class="[$v.value.$error && showErrors ? 'form-group--error' : '']"
          :placeholder="$t('typeToSelect')"
          @blur="getValue"
          @typingAlert="filterAndPropose"
      />
      <div v-if="value && value.length >= 3 && !hasExactMatchingTag && canCreateTags && creatingTagsAllowed">
        <div class="p-2 tag-creation-dropdown">{{ $t('noTagsYet') }}
          <div class="w-100"/>
          <div
              v-if="creatingTagsAllowed"
              class="settings-button d-inline-block mt-1"
              @click="createNewTag"
          >
            {{ $t('createNewType', {type: 'tag'}) }}
            <icon class="ml-1" type="plus"/>
          </div>
        </div>
      </div>
      <div v-if="showErrors">
        <div v-if="errorMessage" class="form-error">{{ errorMessage }}</div>
        <div v-if="!$v.value.minLength && $v.value.$error " class="form-error">
          {{ $t('errors.atLeastCharacters', {num: 3}) }}
        </div>
        <div v-if="!$v.value.alphaNumSpace && $v.value.$error " class="form-error">{{
            $t('errors.alphaNumSpaceOnly')
          }}
        </div>
        <div v-if="!$v.value.isUnique && $v.value.$error " class="form-error">{{
            $t('errors.objectNameAlreadyExists')
          }}
        </div>
      </div>

      <!-- <div
           v-if="creatingTagsAllowed"
           class="input-append-icon interactive"
           @click="createNewTag"
       >
         <icon type="plus"/>
       </div>-->
      <div
          v-if="!showTagListPermanently"
          class="input-prepend-icon interactive"
          @click="toggleTagList"
      >
        <icon v-if="!showTagList" type="angle-down"/>
        <icon v-else type="angle-up"/>
      </div>
    </div>

    <!--Tag list dropdown-->
    <div v-if="hasTags && (showTagList || showTagListPermanently) && !tableMode"
         class="form-dropdown-box">
      <div v-if="message" class="form-small-message">{{ message }}</div>
      <div v-for="(tag, id) in $store.getters.getTags" :key="id"
           @click="() => {
             $emit('addTag', tag);
             showTagList = false
           }">
        <tag
            v-if="!excludeFromTagList || excludeFromTagList.filter(item => {return item.id === tag.id}).length === 0"
            :is-removable="tagsAreDeletable"
            :tag="tag"
            class="mb-1"
            @removeTag="deleteTag"
            @setColor="setColor"
        />
      </div>
    </div>

    <!--Tag list as table-->
    <table-widget v-if="tableMode && $store.getters.getTags"
                  id="taginputTable"
                  :data="$store.getters.getTags"
                  :deletable="true"
                  :fields="fields"
                  class="tag-input-table mt-1"
                  delete-permission="userIsOrganizationMember"
                  edit-permission="userIsOrganizationMember"
                  @deleteRow="deleteTag"
                  @updateColor="setColor"
                  @updateField="updateName"
    />

  </div>
</template>

<script>
import Icon from "../Icon";
import Tag from "../Tag";
import TextInput from "./TextInput";
import TableWidget from "../widgets/TableWidget";
import {minLength} from 'vuelidate/lib/validators';
import {alphaNumSpace} from '../../customValidators';

export default {
  name: "TagInput",
  components: {
    Icon,
    Tag,
    TextInput,
    TableWidget
  },
  validations: {
    value: {
      minLength: minLength(3),
      alphaNumSpace,
      async isUnique(value) {
        // standalone validator ideally should not assume a field is required
        if (value === '') {
          return true;
        }
        let bool = true;
        await this.$store.dispatch('checkIfTagNameExists', {
          value: value,
          organizationId: this.limitTagsToOrganizations[0],
        }).then(data => {
          bool = data.length === 0;
        });
        return bool;
      },
    },
  },
  computed: {
    hasExactMatchingTag() {
        return Object.values(this.$store.getters.getTags).some(tag => tag.name === this.value);
    },
    hasTags() {
      return Object.keys(this.$store.getters.getTags).length > 0;
    },
  },
  props: {
    excludeFromTagList: {type: Array, default: null},
    creatingTagsAllowed: {type: Boolean, default: true},
    showTagListPermanently: {type: Boolean, default: false},
    tagsAreDeletable: {type: Boolean, default: false},
    canSetColor: {type: Boolean, default: false},
    tableMode: {type: Boolean, default: false},
    limitTagsToOrganizations: {
      type: Array, default: () => {
        return []
      }
    },
    excludeVHUBOrganization: {type: Boolean, default: null},
    creationOrganizationId: {type: String, default: null},
  },
  data() {
    return {
      canCreateTags: true,
      showTagList: false,
      showErrors: false,
      errorMessage: '',
      message: '',
      value: '',
      showDeletePrompt: false,
      toBeDeletedTag: null,
      tempTag: null,
      fields: [
        {
          name: 'Name',
          id: 'name',
          type: 'editableText',
          sortable: true
        },
        {
          name: 'Preview',
          id: 'name',
          type: 'tag',
          sortable: true
        },
        {
          name: 'Color',
          id: 'color',
          type: 'color',
          sortable: true
        },
      ],
    }
  },
  watch: {
    limitTagsToOrganizations() {
      this.filterAndPropose({value: ''}, false);
    },
    creationOrganizationId() {
      this.checkTagCreationPermission();
    },
  },
  beforeMount() {
    if (this.tableMode && this.limitTagsToOrganizations) {
      this.filterAndPropose({value: ''});
    }
    this.checkTagCreationPermission();
  },
  methods: {
    closeItemList() {
      this.showTagList = false;
    },
    async checkTagCreationPermission() {
      if(!this.$store.getters.isSuperAdmin) {
        if(!this.creationOrganizationId) {
          this.canCreateTags = false;
          return;
        }
        this.canCreateTags = await this.$store.dispatch('checkTeamOrgPermission', {
          op: 'createTags',
          opOnly: true,
          orgPermissionOnly: true,
          organizationId: this.creationOrganizationId
        });
      }
    },
    clearOutLocalTagsInFrontend() {
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.endsWith('TagFilter')) {
          localStorage.removeItem(key);
        }
      }
    },
    toggleTagList() {
      this.showTagList = !this.showTagList;
      if (this.showTagList) {
        this.loadTags();
      } else {
        this.$refs.textinput.clearValue();
      }
    },
    loadTags() {
      this.showTagList = true;
      this.filterAndPropose({value: ''});
      if (this.$refs.textinput) {
        this.$refs.textinput.clearValue();
      }
    },
    async createNewTag() {
      this.showErrors = true;
      if (!this.value || this.$v.$anyError) {
        return;
      }
      let args = {
        name: this.value,
        organizationId: this.creationOrganizationId
      };
      return await this.$store.dispatch('createTag', args)
          .catch(e => {
            console.log('Tag creation failed:', e);
            this.errorMessage = this.$t('errors.tagCreationFailed', {error: e.message});
            return null;
          })
          .then(newTag => {
            if(!newTag) {
              return;
            }
            this.$emit('addTag', newTag);
            this.loadTags();
            this.resetInput();
          });
    },
    resetInput() {
      if (!this.showTagListPermanently) {
        this.filterAndPropose({value: this.value});
      } else {
        this.$refs.textinput.clearValue();
      }
      this.showErrors = false;
    },
    deleteTag(id) {
      this.$store.dispatch('deleteTag', {id: id});
      this.showDeletePrompt = false;
      this.toBeDeletedTag = null;
      this.clearOutLocalTagsInFrontend();
    },
    stripAlphaFromHex(hex) {
      if (typeof hex !== 'string') return hex; // Not a string? Not my problem.
      hex = hex.trim().replace(/^#/, ''); // Remove leading '#' if present

      if (hex.length === 8) {
        return '#' + hex.slice(0, 6); // Remove alpha (last 2 chars)
      }

      return '#' + hex; // Already clean (or too messy to care)
    },
    async setColor(tag) {
      if (tag.color) {
        tag.color = this.stripAlphaFromHex(tag.color);
      }
      await this.$store.dispatch('updateTag', tag);
      this.clearOutLocalTagsInFrontend();
    },
    async updateName(args) {
      const {id, value} = args;
      this.$store.dispatch('updateTag', {
        id: id,
        name: value,
      }).then(() => {
        this.$store.dispatch('loadTags', {remove: {filter: {}}});
        this.clearOutLocalTagsInFrontend();
      }).catch(() => {
        this.$store.dispatch('loadTags', {remove: {filter: {}}, add: {filter: {}}});
      });
    },
    updateTagColor(input) {
      this.$store.dispatch('updateTag', {
        id: this.tempTag.id,
        color: input,
      });
      this.tempTag = null;
    },
    getValue(id, value) {
      this.value = value;
      this.$v.$touch();
    },
    filterAndPropose(input, showTags = true) {
      let params = '';
      let filterParamId = 'tags';
      this.showTagList = showTags;
      this.message = '';
      let orgFilter = '';
      this.value = input.value;
      this.$v.$touch();
      this.showErrors = false;
      if (this.limitTagsToOrganizations && this.limitTagsToOrganizations.length) {
        if (this.limitTagsToOrganizations.length === 1) {
          orgFilter = 'organizationId eq ' + this.limitTagsToOrganizations[0];
        } else {
          orgFilter = 'organizationId in \'' + this.limitTagsToOrganizations.join("' '") + '\'';
        }
      }
      if (input.value.length > 2) {
        params = {
          add: {
            filter: {
              [filterParamId]: 'name like %' + input.value + '%'
            }
          },
        };
      } else if (input.value.length === 0) {
        params = {
          remove: {
            filter: {filterParamId}
          }
        };

      } else {
        this.message = this.$t('errors.atLeastThreeCharacters');
      }
      if (orgFilter) {
        if (!params) {
          params = {};
        }
        if (!params.add) {
          params.add = {filter: {}};
        }
        params.add.filter.orgFilter = orgFilter;
      } else {
        if (!params) {
          params = {};
        }
        if (!params.remove) {
          params.remove = {filter: {}};
        }
        params.remove.filter.orgFilter = 'orgFilter';
      }
      this.$store.dispatch('loadTags', params);
    },
  }
}
</script>

<style lang="scss">
.tag-input {
  position: relative;

  .form-text {
    margin-bottom: 0;
  }
}

.color-preview {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  cursor: pointer;
  -webkit-transition: all 300ms ease;
  transition: all 300ms ease;
  border: 1px solid transparent;
}

.color-preview-container {
  min-width: 40px;
  height: 100%;
  position: relative;
  display: inline-block;
}

.tag-creation-dropdown {
  background: var(--vform-editor-ui-quinary-color);
}
</style>